export default __webpack_public_path__ + "static/media/G0.faaf3bbb.mp3";